// extracted by mini-css-extract-plugin
module.exports = {"fileStatusContainer":"vacantFileHistory_fileStatusContainer__2QwdO","loadMoreBtnContainer":"vacantFileHistory_loadMoreBtnContainer__ns0TQ"};